import React, { useState } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../context/AuthContext";

const OnHoldMobile = ({ data, screenWidth, onAccept, onReject }) => {
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);

  const { user } = useAuth();

  return (
    <>
      {currentData.length > 0 ? (
        currentData.map((item, index) => (
          <div key={index} className="rounded text-secondary mb-3 text-dark border">
            <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
              <h5 className="text-dark fw-bolder mb-2">{item.biodata_supplier_name}</h5>
            </div>
            <div className="bg-white p-3 rounded-bottom">
              {/* Status */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Status</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  {item.used ? (
                    item.is_accepted ? (
                      <span className="badge text-dark" style={{ backgroundColor: "lightgreen", width: 100 }}>Accepted</span>
                    ) : (
                      <span className="badge text-dark" style={{ backgroundColor: "lightsalmon", width: 100 }}>Rejected</span>
                    )
                  ) : (
                    <span className="badge text-dark" style={{ backgroundColor: "lightgrey", width: 100 }}>Pending</span>
                  )}
                </div>
              </div>
              {/* Vendor Name */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Vendor Name</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.supplier_name}</p>
                </div>
              </div>
              {/* Agency Name */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Agency Name</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.agency_name}</p>
                </div>
              </div>
              {/* Biodata Name */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Biodata Name</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.biodata_supplier_name}</p>
                </div>
              </div>
              {/* Agency Note */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Agency Note</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.agency_note || "-"}</p>
                </div>
              </div>
              {/* Supplier Note */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <p style={{ fontSize: "0.7rem" }}>Supplier Note</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.supplier_note || "-"}</p>
                </div>
              </div>
              {/* Action button */}
              {user?.type === "supplier" && !item.used && (
                <div className="row mt-2">
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      className="btn btn-greys me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#confirmModal"
                      onClick={() => onAccept && onAccept(item)}
                    >
                      Accept
                    </button>
                    <button
                      className="btn btn-greys"
                      data-bs-toggle="modal"
                      data-bs-target="#confirmModal"
                      onClick={() => onReject && onReject(item)}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

      {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
};

OnHoldMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenWidth: PropTypes.number.isRequired,
  onAccept: PropTypes.func,
  onReject: PropTypes.func,
};

export default OnHoldMobile;